'use client';

import Link from 'next/link';

export default function AnalyticsError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-black py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 text-center">
                <div>
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-900 border border-red-700">
                        <svg
                            className="h-6 w-6 text-red-400"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                            />
                        </svg>
                    </div>
                    <h2 className="mt-6 text-3xl font-extrabold text-white">
                        Analytics Error
                    </h2>
                    <p className="mt-2 text-sm text-gray-300">
                        Something went wrong with the analytics dashboard.
                    </p>
                </div>

                <div className="space-y-4">
                    <p className="text-gray-400">
                        We encountered an error while loading the analytics dashboard. This might be due to a temporary issue with the database connection or authentication.
                    </p>

                    <div className="space-y-2">
                        <button
                            onClick={reset}
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-black bg-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white transition-colors mr-2"
                        >
                            Try again
                        </button>
                        <Link
                            href="/"
                            className="inline-flex items-center px-4 py-2 border border-gray-600 text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
                        >
                            Return to Home
                        </Link>
                    </div>
                </div>

                <div className="text-xs text-gray-500">
                    <p>Error Code: 500 Internal Server Error</p>
                    {error.digest && (
                        <p>Error ID: {error.digest}</p>
                    )}
                </div>
            </div>
        </div>
    );
}
